import React, { Component, PropTypes } from 'react';

import Dropdown from '../dropdown/dropdown';

import FBAuth from '../../utils/social/fb';

import css from './share.scss';

import translate from '../../utils/translate';

export default class Share extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		title: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
	};

	static defaultProps = {
		url: window.location.toString(),
	};

	constructor(props) {
		super(props);
		this.fb = new FBAuth();
	}

	componentWillMount() {
		 this.fb.load();
	}

	render() {

		return (
			<div className='social-share'>
				<button ref='share' className='social-share__button'>Share +</button>
				<Dropdown key='dropdown' attachTo={() => this.refs.share} pointTo='BOTTOM_RIGHT' browser={this.props.browser}>
					<ol key='dropdown-ol'>
						<li key='facebook'><a onClick={(event) => this.faceShare(event)} href="#">{translate('socialshare/facebook')}</a></li>
						<li key='twitter'><a onClick={(event) => this.twitterClick(event)} href="#">{translate('socialshare/twitter')}</a></li>
						<li key='google'><a onClick={(event) => this.googleClick(event)} href="#">{translate('socialshare/gplus')}</a></li>
						<li key='linkedin'><a onClick={(event) => this.linkedinClick(event)} href="#">{translate('socialshare/linkedin')}</a></li>
						<li key='email'><a href={'mailto:?subject=The FWA - ' + this.props.title + '&body=' + this.props.url}>{translate('socialshare/email')}</a></li>
					</ol>
				</Dropdown>
			</div>
		);
	}

	twitterShare(url, winWidth = 520, winHeight = 350) {
		let winTop = (screen.height / 2) - (winHeight / 2);
				let winLeft = (screen.width / 2) - (winWidth / 2);
				window.open('https://twitter.com/intent/tweet?text=' + this.props.title + '&url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

		}

	googleShare(url, winWidth = 520, winHeight = 350) {
		let winTop = (screen.height / 2) - (winHeight / 2);
				let winLeft = (screen.width / 2) - (winWidth / 2);
				window.open('https://plus.google.com/share?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

		}

	linkedinShare(url, winWidth = 520, winHeight = 350) {
		let winTop = (screen.height / 2) - (winHeight / 2);
				let winLeft = (screen.width / 2) - (winWidth / 2);
				window.open('https://www.linkedin.com/cws/share?url=' + url, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);

		}

	faceShare(e) {
		e.preventDefault();
		this.fb.share(this.props.url);
	}

	twitterClick(e) {
		e.preventDefault();
		let url = this.props.url;
		let hashtag = translate('socialshare/hashtag');
		url += '&hashtags=' + hashtag;
		this.twitterShare(url);
	}

	googleClick(e) {
		e.preventDefault();
		let url = this.props.url;
		this.googleShare(url);
	}

	linkedinClick(e) {
		e.preventDefault();
		let url = this.props.url;
		this.linkedinShare(url);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/share/share.js
 **/